// Words for the Topics section and four invented, neutral example topics, written by the Chat Quality session. Used verbatim.
// [Bracketed] parts must be replaced by the owner; the editor points them out.
export const TOPICS_TEXT = {
  what: {
    en: "A topic is an exact answer you write yourself. When a visitor's message contains one of its trigger phrases, the agent sends your answer word for word and the AI is not used. An FAQ is different: it is knowledge the agent reads and puts in its own words.",
    es: "Un tema es una respuesta exacta que escribes tú. Cuando el mensaje del visitante contiene una de sus frases disparadoras, el agente envía tu respuesta tal cual y no usa la IA. Una pregunta frecuente es distinta: es conocimiento que el agente lee y expresa con sus propias palabras.",
  },
  matching: {
    en: "A trigger matches when its words appear together, in that order, anywhere in the message. Capitals, accents and punctuation don't matter. If several topics match, the first one in the list is used. Add each way people ask as a separate trigger; avoid single common words.",
    es: "Un disparador coincide cuando sus palabras aparecen juntas, en ese orden, en cualquier parte del mensaje. No importan mayúsculas, acentos ni signos. Si coinciden varios temas, se usa el primero de la lista. Añade cada forma de preguntar como un disparador aparte; evita palabras sueltas muy comunes.",
  },
  examples: [
    {
      id: "hours",
      title: { en: "Opening hours", es: "Horario" },
      triggers: { en: ["opening hours", "what time do you open", "are you open"], es: ["horario", "a que hora abren", "estan abiertos"] },
      answer: {
        en: "We are open Monday to Friday, 9:00 to 17:00. We are closed on weekends and public holidays.",
        es: "Abrimos de lunes a viernes, de 9:00 a 17:00. Cerramos los fines de semana y festivos.",
      },
    },
    {
      id: "contact",
      title: { en: "Contact us", es: "Contacto" },
      triggers: { en: ["contact us", "talk to a person", "phone number"], es: ["contactar", "hablar con una persona", "telefono"] },
      answer: {
        en: "You can reach our team at [email or phone]. We reply within one business day.",
        es: "Puedes escribir a nuestro equipo en [correo o teléfono]. Respondemos en un día hábil.",
      },
    },
    {
      id: "buy",
      title: { en: "Where to buy", es: "Dónde comprar" },
      triggers: { en: ["where can i buy", "where to buy", "online store"], es: ["donde comprar", "donde puedo comprar", "tienda en linea"] },
      answer: {
        en: "You can buy from our online store at [link] or from an authorized reseller. Tell me your country and I can help.",
        es: "Puedes comprar en nuestra tienda en línea [enlace] o con un distribuidor autorizado. Dime tu país y te ayudo.",
      },
    },
    {
      id: "refund",
      title: { en: "Refund policy", es: "Política de reembolso" },
      triggers: { en: ["refund policy", "can i get a refund", "return policy"], es: ["politica de reembolso", "puedo pedir un reembolso", "devoluciones"] },
      answer: {
        en: "You can request a refund within 30 days of purchase if the product is unused. Write to [email] with your order number.",
        es: "Puedes pedir un reembolso dentro de 30 días de la compra si el producto no se ha usado. Escribe a [correo] con tu número de pedido.",
      },
    },
  ],
} as const;

/** True while an answer still has a [bracketed] part from an example. */
export const hasPlaceholder = (text: string) => /\[[^\]]+\]/.test(text);
